import React, { useContext } from 'react'
import NapaLogoBlue from '../../../assets/napa_logo_blue.png'
import { Document, Image, Page, Text, View } from '@react-pdf/renderer'
import language from '../../../language/language'
import { LanguageContext } from '../../../utilities/contexts/LanguageContext'
import { PrintableReturnStyles } from './PrintableReturnStyles'

type PrintableReturnProps = {
  selectedReturn: any
}
export const PrintableReturn = ({ selectedReturn }: PrintableReturnProps) => {
  const { currentLanguage } = useContext(LanguageContext)

  const TableHeader = () => (
    <View style={PrintableReturnStyles.tableRow} wrap={false}>
      <Text style={PrintableReturnStyles.tableColHeader}>LINE</Text>
      <Text style={PrintableReturnStyles.tableColHeader}>PART NUMBER</Text>
      <Text style={PrintableReturnStyles.tableColHeader}>DESCRIPTION</Text>
      <Text style={PrintableReturnStyles.tableColHeader}>QTY</Text>
      <Text style={PrintableReturnStyles.tableColHeader}>TYPE</Text>
      <Text style={PrintableReturnStyles.tableColHeader}>ADDED</Text>
      <Text style={PrintableReturnStyles.tableColHeader}>NOTES</Text>
      <Text style={[PrintableReturnStyles.tableColHeader, PrintableReturnStyles.lastColHeader]}>
        STATUS
      </Text>
    </View>
  )

  // Component that renders one row of data
  const TableRow = ({ item }: any) => (
    <View style={PrintableReturnStyles.tableRow} wrap={false}>
      <Text style={PrintableReturnStyles.tableCol}>{item.productLine}</Text>
      <Text style={PrintableReturnStyles.tableCol}>{item.partNumber}</Text>
      <Text style={PrintableReturnStyles.tableCol}>{item.description}</Text>
      <Text style={PrintableReturnStyles.tableCol}>{item.qty}</Text>
      <Text style={PrintableReturnStyles.tableCol}>{item.partType}</Text>
      <Text style={PrintableReturnStyles.tableCol}>
        {item.isPartScanned ? 'Manual' : 'Scanned'}
      </Text>
      <Text style={PrintableReturnStyles.tableCol}>{item.notes}</Text>
      <Text style={[PrintableReturnStyles.tableCol, PrintableReturnStyles.lastCol]}>
        {item.partStatus}
      </Text>
    </View>
  )

  const PDFDataGrid = ({ data }: any) => (
    <View style={PrintableReturnStyles.table}>
      <TableHeader />
      {data.partDetails?.map((row: any, index: any) => (
        <TableRow key={index} item={row} />
      ))}
    </View>
  )

  //TODO: Complete styling, finish transferring text to language files.
  return (
    <Document>
      <Page style={PrintableReturnStyles.page}>
        <Image src={NapaLogoBlue} style={PrintableReturnStyles.headerImage} />
        <View style={PrintableReturnStyles.header}>
          <View>
            <Text style={PrintableReturnStyles.customerNameTitle}>
              {selectedReturn?.customerName}
            </Text>
            <Text style={PrintableReturnStyles.boldText}>
              {language[currentLanguage].account}: {selectedReturn.customerNumber}
            </Text>
            <Text style={PrintableReturnStyles.text}>
              {language[currentLanguage].returnNumber}:
              <Text style={PrintableReturnStyles.boldText}>{selectedReturn.returnId}</Text>
            </Text>
          </View>
          <View>
            <Text style={PrintableReturnStyles.text}>
              {language[currentLanguage].driver}: {selectedReturn.printName}
            </Text>
            <Text style={PrintableReturnStyles.text}>
              {language[currentLanguage].completed}: {selectedReturn.completionTimestamp}
            </Text>
            <Text style={PrintableReturnStyles.text}>
              {language[currentLanguage].received}: {selectedReturn.creationTimestamp}
            </Text>
          </View>
        </View>
        <PDFDataGrid data={selectedReturn} />
        <Text style={PrintableReturnStyles.signatureTitle}>
          {language[currentLanguage].signature}
        </Text>
        <Text style={PrintableReturnStyles.text}>
          {language[currentLanguage].signedBy}: {selectedReturn.printName}
        </Text>
        <Image style={PrintableReturnStyles.signatureImage} src={selectedReturn.signature} />
        <View style={PrintableReturnStyles.verificationTextContainer}>
          <Text style={PrintableReturnStyles.verificationText}>
            {language[currentLanguage].returnsSubjectVerification}
          </Text>
        </View>
      </Page>
    </Document>
  )
}
